import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { createValidator, required } from 'utils/formValidations';
import { setError } from '@/actions';
import { formErrors } from '@/actions/purchase';

const validateLegalTerms = createValidator({ legalTerms: required });

/** Own the purchaser agreements when Quick Purchase collects buyer details elsewhere. */
function QuickCheckoutAgreementForm({ handleSubmit, purchaserAgreementContent }) {
  return <form onSubmit={handleSubmit}>{purchaserAgreementContent}</form>;
}

QuickCheckoutAgreementForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  purchaserAgreementContent: PropTypes.node.isRequired,
};

export default reduxForm({
  form: 'purchaser',
  destroyOnUnmount: false,
  validate: (values, { quickCheckoutAgreementPolicy }) =>
    quickCheckoutAgreementPolicy.legalRequired ? validateLegalTerms(values) : {},
  onSubmitFail: (fields, dispatch, submitError, { onSubmitPurchaserFail }) => {
    if (onSubmitPurchaserFail) onSubmitPurchaserFail();
    // eslint-disable-next-line prettier/prettier
    dispatch(setError(200, 'check_the_fields_in_red', 'warning', false, null, null, null, 'fixed'));
    dispatch(formErrors(1, fields));
  },
})(QuickCheckoutAgreementForm);
